import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { EarningsItem } from "../types";
import { loadSecurityEarnings } from "../thunks/getSecurityEarningsThunk";

export const useDisplaySecurityEarnings = (
  symbol?: string
) => {
  const storeStatistics = useSelector<
    StoreType,
    EarningsItem | undefined
  >((store) => store.data.reports.securityStatistics.displaySecurityEarnings);

  const displayedStatisticsearnings =
    storeStatistics && storeStatistics.symbol === symbol
      ? storeStatistics
      : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (symbol) {
      dispatch(loadSecurityEarnings( symbol));
    }
  }, [dispatch, symbol]);

  return displayedStatisticsearnings;
};